import styled from '@emotion/styled';
import { Layout, Skeleton, message } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { appStyles } from '../../../../styles';
import { getImagesRepository } from '../../../../repository/mytm/image/imageRepository';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { SpinLoading } from '../../../atoms/loading/SpinLoading';
import { ImagesTable } from '../../../organisms/graphics/ImagesTable';
import { OtherGraphicsHeader } from './other-graphic/OtherGraphicsHeader';
import { CreateImageModal } from './other-graphic/form/CreateImageModal';

const { Content } = Layout;

export const OtherGraphics = () => {
  const [listImages, setListImages] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<any>(false);

  const handleGetImages = useCallback(async (loading?: boolean) => {
    try {
      setIsLoading(loading);
      const images = await getImagesRepository();
      if (images.length === 0) {
        setListImages([]);
        setIsLoading(false);
        return;
      }
      const data = images.map((item, index) => ({
        index,
        ...item,
      }));

      setListImages(data);
      setIsLoading(false);
    } catch (e) {
      setListImages([]);
      setIsLoading(false);
      message.error(MESSAGE_ERROR.M03);
    }
  }, []);

  const onLoading = useCallback((loading: boolean) => {
    setIsLoading(loading);
  }, []);
  // Modal
  const [currentRecord, setCurrentRecord] = useState<any>();
  const [isOpenImageModal, setIsOpenCreateImageModal] = useState(false);
  const onOpenCreateImageModal = useCallback(() => {
    setIsOpenCreateImageModal(true);
  }, []);

  const onCloseImageModal = useCallback(() => {
    setIsOpenCreateImageModal(false);
    setCurrentRecord(undefined);
  }, []);

  const onHandleClickBtnEdit = useCallback((record: any) => {
    setCurrentRecord(record);
    setIsOpenCreateImageModal(true);
  }, []);

  useEffect(() => {
    handleGetImages();
  }, [handleGetImages]);
  return (
    <SpinLoading isLoading={isLoading} absolute>
      <>
        {!listImages && <Skeleton />}
        {listImages && (
          <Container>
            <Content>
              <OtherGraphicsHeader onOpenCreateImageModal={onOpenCreateImageModal} />
              <ImagesTable
                records={listImages}
                onHandleClickBtnEdit={onHandleClickBtnEdit}
                onRefresh={handleGetImages}
                onLoading={onLoading}
              />
              <CreateImageModal
                isOpenModal={isOpenImageModal}
                onClose={onCloseImageModal}
                record={currentRecord}
                onRefresh={handleGetImages}
              />
            </Content>
          </Container>
        )}
      </>
    </SpinLoading>
  );
};

const Container = styled.div`
  ${appStyles.paddingComponent}
`;
